<template>
  <v-layout align-center column style="margin-top: 100px;">
    <p class="Section-Title">Keuntungan Pinjaman di Dompet Kilat</p>
    <v-row align="center" justify="center">
      <v-col class="Proses-Mudah">
        <v-skeleton-loader
          type="image"
          height="80"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pinjaman/Mudah.png"
          srcset="
            ../../assets/pinjaman/Mudah@2x.png 2x,
            ../../assets/pinjaman/Mudah@3x.png 3x
          "
          @load="onImgLoad"
          class="Mudah"
        />
        <p class="Title-Mudah">Proses Mudah</p>
        <p class="Desc">Proses pengajuan peminjaman cepat dan mudah.</p>
      </v-col>
      <v-col class="Bunga-Rendah">
        <v-skeleton-loader
          type="image"
          height="80"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pinjaman/Bunga.png"
          srcset="
            ../../assets/pinjaman/Bunga@2x.png 2x,
            ../../assets/pinjaman/Bunga@3x.png 3x
          "
          @load="onImgLoad"
          class="Bunga"
        />
        <p class="Title-Bunga">Bunga Kompetitif</p>
        <p class="Desc">
          Bunga pengembalian rendah mulai dari 1,25% per bulan.
        </p>
      </v-col>
      <v-col class="Transparant-Box">
        <v-skeleton-loader
          type="image"
          height="80"
          v-if="!isImgLoaded"
        ></v-skeleton-loader>
        <img
          src="../../assets/pinjaman/Transparant.png"
          srcset="
            ../../assets/pinjaman/Transparant@2x.png 2x,
            ../../assets/pinjaman/Transparant@3x.png 3x
          "
          @load="onImgLoad"
          class="Transparant"
        />
        <p class="Title-Transparant">Transparant & Flexible</p>
        <p class="Desc">
          Perjanjian transparan dengan tenor dan limit yang disesuaikan dengan
          kebutuhan.
        </p>
      </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Mudah {
  max-width: 118px;
  max-height: 118px;
  flex-grow: 0;
  margin: 0 102px 12px 90px;
  object-fit: contain;
}
.Text-Hero {
  width: 590px;
  height: 168px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Bunga {
  /* width: 80px; */
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 102px 12px 90px;
  object-fit: contain;
}
.Transparant {
  /* width: 80px; */
  /* height: 80px; */
  align-self: center;
  flex-grow: 0;
  margin: 0 102px 12px 90px;
  object-fit: contain;
}
.Proses-Mudah {
  width: 285px;
  flex-grow: 0;
  margin: 60px 3px 0 0;
}
.Bunga-Rendah {
  width: 285px;
  flex-grow: 0;
  margin: 60px 96px 0;
}
.Transparant-Box {
  width: 285px;
  flex-grow: 0;
  margin: 60px 0 0 2px;
}
.Desc {
  width: 285px;
  height: 44px;
  flex-grow: 0;
  margin: 10px 0 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Mudah {
  width: 285px;
  height: 20px;
  flex-grow: 0;
  margin-left: 4px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Bunga {
  width: 285px;
  height: 20px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Title-Transparant {
  width: 285px;
  height: 20px;
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Section-Title {
  /* width: 472px; */
  height: 30px;
  flex-grow: 0;
  margin: 0px 2px 60px 3px;
  font-family: Sora;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
@media screen and (max-width: 1042px) {
  .Section-Title {
    /* width: 472px; */
    height: 30px;
    flex-grow: 0;
    margin: 80px 2px 20px 3px;
    font-family: Sora;
    font-size: 28px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
  .Proses-Mudah {
    width: 185px;
    height: 66px;
    flex-grow: 0;
    margin-bottom: 10%;
    margin-left: -18%;
  }
  .Bunga-Rendah {
    width: 185px;
    height: 66px;
    flex-grow: 0;
    margin-bottom: 10%;
  }
  .Transparant-Box {
    width: 185px;
    height: 66px;
    flex-grow: 0;
    margin-bottom: 10%;
  }
}
@media screen and (max-width: 842px) {
  .Section-Title {
    /* width: 472px; */
    height: 30px;
    flex-grow: 0;
    margin: 80px 2px 10px 3px;
    font-family: Sora;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
</style>
